import React, { useEffect , useState, useContext} from 'react';
import "./Reports.css";
import { Typography } from '../../../../node_modules/@mui/material/index';
import * as moment from "moment";
import Context from "context/context";
import { toast } from "react-toastify";

// material ui
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Card from "@mui/material/Card";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from '@mui/material/Pagination';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { toastCss, theme } from "config/config";

// api imports
import reportsAPI from 'apis/panel/reports/reports';

import exportIcon from "assets/images/Vector (8).png";


// import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';

// import { useNavigate } from '../../../../node_modules/react-router-dom/dist/index';

import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    cursor: "pointer",
    backgroundColor: "#002c5d",
    color: "#ffffff",
  },
});

const ProjectSetup = () => {

  const { dispatch } = useContext(Context);
  const [projects, setProjects] = useState([]);
  const [TaskList , setTaskList] = useState([])
  const [selectedProjectId , setSelectedProjectId]= useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  
  const [page, setPage] = useState(1);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [submitted, setSubmitted] = useState(false);
  const [startDate, setStartDate]= useState(null);
  const [submitClicked, setSubmitClicked]= useState(false);
  const [endDate, setEndDate]= useState(null)
  const [projectName,setProjectName]= useState('')
  const [projectStatus,setProjectStatus] = useState('Active')

  const navigate=useNavigate()

  const itemsPerPage=10

  const { getAllProjectNames, getAllProjectTasks, getWeeklyReportAPI } = reportsAPI();

  const handleProjects = async () => {
    try {
      const res = await getAllProjectNames(projectStatus);
      setProjects(res?.data?.projects || []);
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };

  

  useEffect(() => {
    handleProjects();
    
    if (submitClicked || submitted) {
      handleSubmit();
     
    }
   
  }, [offset]);

  useEffect(()=>{
   
    setTaskList([])
    setCount(0)
      setSelectedProjectId([])
    
      setProjectName('')
      setSubmitClicked(false)
      setSubmitted(false)
      
 handleProjects();
  },[projectStatus])

 
  const handleExport = async (rowData) => {
    
   let body = {
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD"),
      taskId:rowData.task_id,
      projectId:selectedProjectId
    };

    dispatch({ type: "SET_LOADING", payload: true });
    // setDisableDropdown(true);
   
    await getWeeklyReportAPI(body);
    dispatch({ type: "SET_LOADING", payload: false });
  };



  const handleview = async (rowData) => {
    
    let body = {
      startDate: moment(startDate).format('YYYY-MM-DD'),
      endDate: moment(endDate).format('YYYY-MM-DD'),
       taskId:rowData.task_id,
       projectId:selectedProjectId,
       projectName:projectName
       
     };
     openNewTabWithState(body);

   
   };

   const openNewTabWithState = (body) => {
    const queryString = encodeStateToQueryString(body);
    window.open(`/panel/weeklyReports?${queryString}`, '_blank', 'noopener,noreferrer');
  };

  const encodeStateToQueryString = (state) => {
  return new URLSearchParams(state).toString();
};

 
const handleProjectId=async(projectId)=>{


  setSelectedProjectId(projectId)  
}

useEffect(()=>{
  projects.forEach(id => {
    if(id.projectId===selectedProjectId){
      setProjectName(id.projectName)
    }
  });
},[selectedProjectId])

 
  const handleGetProjectTasks = async (selectedProjectId) => {
    let values;
    values = {
        offset: (offset - 1) * 10,
        limit: 10,
       id:selectedProjectId
    };
 
    try {
      dispatch({ type: "SET_LOADING", payload: true });
        let res = await getAllProjectTasks(values);
      
        setCount(res?.data?.count);
        setTaskList(res?.data?.tasks || [])
       
         dispatch({ type: "SET_LOADING", payload: false });
    }
    catch (err) {
        setLoading(false);
    }
};


const indexOfLastItem = currentPage * perPage;
    const indexOfFirstItem = indexOfLastItem - perPage;

const handlePagination = (value) => {

  setOffset(value);
};


  const handleSubmit=()=>{
  
    setSubmitClicked(true)
    if(!startDate || !endDate ){
      setSubmitted(false);
    }
    if (selectedProjectId !='' ) {
      setSubmitted(true);
      handleGetProjectTasks(selectedProjectId);
      
    } 
  }


  const getStatusColor = (status) => {
    return status === 'Active' ? 'green' : 'red';
  };


    const heading=[
            "S.No",
            "Project Type",
            "Task Name",
            "Cost Center",
            "Status",
            "Action"
    ]

     const statusLabels = {
  Active: "Active",
  Inactive: "In Active",
};

  return (
    <div>

<Grid container spacing={2} sx={{ mt: 2 }} alignItems="flex-start">

   {/* Employee status */}
 <Grid item xs={12} sm={6} md={6} lg={6}>
    <Box className="label">Project Status
      <span style={{ color: "red" }}>*</span>
    </Box>
    <FormControl fullWidth>
      <Select
        labelId="vra-label-2"
        id="projectStatus"
        name="projectStatus"
       
        displayEmpty
        value={projectStatus}
        onChange={(e) => {
          setProjectStatus(e.target.value);
        }}
        inputProps={{ "aria-label": "Timesheet Status" }}
        renderValue={(selected) => {
        if (!selected) {
          return <em>Select Status</em>;
        }
       return statusLabels[selected];
      }}
      >
        
        <MenuItem value={'Active'}>Active</MenuItem>
        <MenuItem value={'Inactive'}>In Active</MenuItem>
       
      </Select>
    </FormControl>
  </Grid>

{/* project name */}
  <Grid item xs={12} sm={6} md={6} lg={6} >
    <Box className="label">Project Name
      <span style={{ color: "red" }}>*</span>
    </Box>
    <FormControl fullWidth>
      <Select
     
        
        id="maritalStatus"
        placeholder="Select ID Proof"
        inputProps={{ "aria-label": "Without label"}}
        value={selectedProjectId}
        onChange={(e) => handleProjectId(e.target.value)}
        displayEmpty
      
      >

  <MenuItem value="" disabled>Select Project</MenuItem>
              {projects.map((project, index) => (
                <MenuItem key={index} value={project.projectId}>
                  {project.projectName}
                  {/* {project.projectName} {`(${typeof project?.status ==="boolean"? project?.status?.toString():project?.status})`} */}
                </MenuItem>
              ))}
      </Select>
    </FormControl>
    {submitClicked && selectedProjectId=='' && (
    <Box sx={{ color: 'red', fontSize: '13px' }}>
        <span>*</span> Required field
    </Box>
)}
  </Grid>
  

{/* Start date */}
  <Grid item xs={12} sm={6} md={6} lg={6} >
    <Box className="label">Start Date
      <span style={{ color: "red" }}>*</span>
    </Box>
    <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
    <DatePicker
            sx={{ width:"100%" }}
              id  = "startDate"
              name="startDate"
              placeholder="Start Date"
              // className="dateInputforstrtDate"
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
              format="dd-MMM-yyyy"
              maxDate={new Date()}
              renderInput={(params) => <TextField {...params} label="Start Date" placeholder="Select Start Date" fullWidth />}
            />
    </LocalizationProvider>
    {submitClicked && !startDate && (
    <Box sx={{ color: 'red', fontSize: '13px' }}>
        <span>*</span> Required field
    </Box>
)}

    
  </Grid>
{/* End Date */}
  <Grid item xs={12} sm={6} md={6} lg={6} >
    <Box className="label">End Date
      <span style={{ color: "red" }}>*</span>
    </Box>
    <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
    <DatePicker
              sx={{ width: "100%" }}
              id="endDate"
              name="endDate"
              // className="dateInputforstrtDate"
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              format="dd-MMM-yyyy"
              minDate={startDate}
              maxDate={new Date()}
              
              renderInput={(params) => <TextField {...params} label="End Date" placeholder="End Date" fullWidth />}
            />
     
    </LocalizationProvider>
    {submitClicked && !endDate && (
    <Box sx={{ color: 'red', fontSize: '13px' }}>
        <span>*</span> Required field
    </Box>
)}

  </Grid>

 
<Grid item xs={12} sm={8} md={8} lg={8} >
    
   
  </Grid>

 {/* Submit button */}
 <Grid
    item
    xs={4}
    style={{
      display: "flex",
      justifyContent: "flex-end",
      padding: "20px 0",
    }}
  >
    <button className="projectsetupSubmitButton" onClick={handleSubmit}>
      Submit
    </button>
  </Grid>

</Grid>

<Grid>

 
        {submitted && startDate && endDate?  (
          <>
          <TableContainer>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  {heading.map((h, i) => (
                    <TableCell key={i}>
                      <b className="tablecellforemployeeRoster">{h}</b>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {TaskList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={heading.length} sx={{ textAlign: 'center'}}>
                      No tasks found
                    </TableCell>
                  </TableRow>
                ) : (
                  TaskList.map((task, i) => (  
                    <TableRow key={i}>
                      <TableCell className="TableCell">{(offset - 1) * itemsPerPage + i + 1}</TableCell>
                      <TableCell className="TableCell">{task?.project_type_name}</TableCell>
                      <TableCell className="TableCell">{task?.task_name}</TableCell>
                      <TableCell className="TableCell">{task?.cost_center}</TableCell>
                      <TableCell   className="TableCell">
                         <span style={{ color: getStatusColor(task.status),  fontWeight :"700"}}>{task.status}</span>
                      </TableCell>

                      <TableCell className="TableCell"  style={{ alignItems:"center"}} >
                        <div style={{textAlign:"center", alignContent:"center", alignItems:"center", display:"flex",gap:"2%"}}>
                        <CustomWidthTooltip
          title='Export'
        >  
                      <div> <img  onClick={() => handleExport(task)}  src={exportIcon} alt=""/></div> 
                      </CustomWidthTooltip>
                      <CustomWidthTooltip
          title='Click to view details'
        >  
                       <div> <VisibilityIcon  style={{color:"#E97000"}} onClick={() => handleview(task)}/></div>
                        
                        </CustomWidthTooltip>
                        </div> 
                      </TableCell>
                    </TableRow>
                    ))  
                )}
                
              </TableBody>
              
            </Table>
          </TableContainer>
           <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Pagination
                    count={(count /itemsPerPage ) % 1 == 0 ? Math.floor(count / itemsPerPage) : Math.floor(count / itemsPerPage + 1)}
                    page={offset}
                    siblingCount={1}
                    onChange={(event, value) => {
                        handlePagination(value);
                    }}
                    color="primary"
                /> 


{/* <Pagination
                count={Math.ceil(count / itemsPerPage)}
                page={offset}
                siblingCount={1}
                onChange={(event, value) => handlePagination(value)}
                color="primary"
              /> */}
            </Box>
            
          </>
          
          
          
        ):(
          <Typography variant="h6" sx={{ mt: 3, textAlign: 'center' ,color: "grey"}}>
            No data available
          </Typography>
        ) }
        
      </Grid>
    </div>
  )
}






export default ProjectSetup